import { __extends, __assign } from 'tslib';
import React__default, { createRef } from 'react';
import Input from '../Input/Input.component.js';
import { EValidationFields, defaultProps } from './PaymentForm.types.js';
import { isValidUSorCanadaPostalCode } from './PaymentForm.utils.js';
import { Variants } from '../Input/Input.types.js';
import styles from './PaymentForm.module.scss.js';

///////////////////////////////////////////////////////////////////////////////
var PaymentForm = /** @class */ (function (_super) {
    __extends(PaymentForm, _super);
    function PaymentForm(props) {
        var _this = _super.call(this, props) || this;
        // collect.js input field wrappers (contains labels and error messages)
        _this.ccNumberWrapperRef = createRef();
        _this.ccExpWrapperRef = createRef();
        _this.cvvWrapperRef = createRef();
        _this.id = Math.floor(Math.random() * Math.floor(9999)).toString();
        _this.areInputsRounded = _this.props.variant === Variants.ROUNDED;
        _this.state = {
            // whether or not the postal code input field has been touched
            isPostalCodeDirty: false,
            isFieldsAvailable: false,
            // a flag to help determine if input is focused or not
            isFocused: false,
        };
        // bind all the things!
        _this.handleChangePostalCode = _this.handleChangePostalCode.bind(_this);
        _this.collectCallback = _this.collectCallback.bind(_this);
        _this.setValidLabel = _this.setValidLabel.bind(_this);
        _this.setErrorLabel = _this.setErrorLabel.bind(_this);
        _this.showInput = _this.showInput.bind(_this);
        _this.hasPreviousInfo = _this.hasPreviousInfo.bind(_this);
        _this.hasPreviousInfoIgnoreFocus = _this.hasPreviousInfoIgnoreFocus.bind(_this);
        _this.formatExpirationDate = _this.formatExpirationDate.bind(_this);
        _this.validationCallback = _this.validationCallback.bind(_this);
        _this.handleFocusInput = _this.handleFocusInput.bind(_this);
        _this.handleBlurInput = _this.handleBlurInput.bind(_this);
        _this.fieldsAvailableCallback = _this.fieldsAvailableCallback.bind(_this);
        _this.renderError = _this.renderError.bind(_this);
        return _this;
    }
    // load collect js on initialization
    PaymentForm.prototype.componentDidMount = function () {
        // TODO: see if there is a better way of doing this... maybe react-helmet?
        if (!window.CollectJS) {
            console.error('Could not load collect.js');
            return;
        }
        var configuration = {
            variant: 'inline',
            styleSniffer: 'false',
            fields: {
                ccnumber: {
                    selector: "#collectjs-ccnumber-" + this.id,
                    title: 'Card Number',
                    placeholder: '0000 0000 0000 0000',
                },
                ccexp: {
                    selector: "#collectjs-ccexp-" + this.id,
                    title: 'Card Expiration',
                    placeholder: '00 / 00',
                },
                cvv: {
                    display: 'required',
                    selector: "#collectjs-cvv-" + this.id,
                    title: 'Security Code',
                    placeholder: '***',
                },
            },
            googleFont: 'Poppins:400',
            customCss: {
                'border-color': '#77819C',
                color: '#030D0F',
                'border-style': 'solid',
                'border-width': '1px',
                'border-radius': '4px',
                'font-size': '0.875rem',
                height: '44px',
                'line-height': '1.5',
                padding: '0 8px',
                'font-family': 'Lato',
                'outline-style': 'none',
            },
            validCss: {
                'border-color': '#77819C',
                color: '#030D0F',
                'border-style': 'solid',
                'border-width': '1px',
                'font-size': '0.875rem',
                height: '44px',
                'line-height': '1.5',
                'outline-style': 'none',
                padding: '0 8px',
            },
            invalidCss: {
                'border-color': '#E80134',
                color: '#030D0F',
                'border-style': 'solid',
                'border-width': '1px',
                'font-size': '0.875rem',
                height: '44px',
                'line-height': '1.5',
                'outline-style': 'none',
                padding: '0 8px',
            },
            focusCss: {
                'border-color': '#1769FF',
                color: '#030D0F',
                'border-style': 'solid',
                'border-width': '1px',
                'font-size': '0.875rem',
                height: '44px',
                'line-height': '1.5',
                padding: '0 8px',
                'outline-style': 'none',
                'box-shadow': 'none',
            },
            placeholderCss: {
                'font-family': 'Lato, sans-serif',
                'font-size': '0.85rem',
                color: '#C0C3C3',
                'text-indent': '4px',
            },
            callback: this.collectCallback,
            validationCallback: this.validationCallback,
            fieldsAvailableCallback: this.fieldsAvailableCallback,
        };
        // configure collect.js
        window.CollectJS.configure(configuration);
    };
    PaymentForm.prototype.componentWillUnmount = function () {
        // Remove event listeners from the iFrames
        var frames = document.querySelectorAll("." + styles.Input + " iframe.CollectJSInlineIframe");
        if (frames) {
            for (var i = 0; i < frames.length; i++) {
                frames[i].removeEventListener('focus', this.handleFocusInput);
                frames[i].removeEventListener('blur', this.handleBlurInput);
            }
        }
    };
    // what to do when the postal code gets updated
    PaymentForm.prototype.handleChangePostalCode = function (event) {
        var _a = this.props, validPostalCode = _a.validPostalCode, invalidPostalCode = _a.invalidPostalCode, setPostalCode = _a.setPostalCode;
        var postalCode = event.target.value;
        if (isValidUSorCanadaPostalCode(postalCode)) {
            validPostalCode();
        }
        else {
            invalidPostalCode('Postal Code is not a valid US or Canadian code');
        }
        setPostalCode(postalCode);
        this.setState({
            isPostalCodeDirty: true,
        });
    };
    // What to do when CollectJS completes a payment submission
    //  param {Object} response - the collect.js callback response object
    PaymentForm.prototype.collectCallback = function (response) {
        var _a = this.props, submittedPaymentInfo = _a.submittedPaymentInfo, setCCNumber = _a.setCCNumber, setExpirationDate = _a.setExpirationDate, setCardBin = _a.setCardBin, setCardHash = _a.setCardHash;
        submittedPaymentInfo(response.token);
        setCCNumber(response.card.number);
        setExpirationDate(response.card.exp);
        setCardBin(response.card.bin);
        setCardHash(response.card.hash);
    };
    // Add a valid class to the collect.js input field wrappers
    PaymentForm.prototype.setValidLabel = function (ref) {
        var current = ref.current;
        if (current) {
            current.classList.remove(styles.Input___error);
            current.classList.add(styles.Input___valid);
        }
    };
    // Add an error class to the collect.js input field wrappers
    PaymentForm.prototype.setErrorLabel = function (ref) {
        var current = ref.current;
        if (current) {
            current.classList.remove(styles.Input___valid);
            current.classList.add(styles.Input___error);
        }
    };
    // show the input when the user clicks on a label that is blocking the
    // input field
    PaymentForm.prototype.showInput = function (ref) {
        var current = ref.current;
        if (current) {
            current.classList.add(styles.Input___focus);
            this.setState({
                isFocused: true,
            });
        }
    };
    // If we have previous information and the form hasn't been focused
    PaymentForm.prototype.hasPreviousInfo = function () {
        var _a = this.props, isPristine = _a.isPristine, hasPaymentToken = _a.hasPaymentToken;
        var isFocused = this.state.isFocused;
        return isPristine && hasPaymentToken && !isFocused;
    };
    // If we have previous information and the form
    PaymentForm.prototype.hasPreviousInfoIgnoreFocus = function () {
        var _a = this.props, isPristine = _a.isPristine, hasPaymentToken = _a.hasPaymentToken;
        return isPristine && hasPaymentToken;
    };
    // Format a previoius expiration date
    PaymentForm.prototype.formatExpirationDate = function (date) {
        return date.substring(0, 2) + "/" + date.substring(2);
    };
    // Handle any validation messages
    //  param {string} fieldName - the name of the collectjs field validated
    //  param {boolean} valid - is the field valid or not
    //  param {string} message - the error message
    PaymentForm.prototype.validationCallback = function (fieldName, valid, message) {
        var _a = this.props, validCCNumber = _a.validCCNumber, validCVVNumber = _a.validCVVNumber, validExpirationDate = _a.validExpirationDate, invalidCCNumber = _a.invalidCCNumber, invalidCVVNumber = _a.invalidCVVNumber, invalidExpirationDate = _a.invalidExpirationDate;
        if (valid) {
            switch (fieldName) {
                case EValidationFields.CC_NUMBER: {
                    this.setValidLabel(this.ccNumberWrapperRef);
                    validCCNumber();
                    break;
                }
                case EValidationFields.CVV: {
                    this.setValidLabel(this.cvvWrapperRef);
                    validCVVNumber();
                    break;
                }
                case EValidationFields.CC_EXPIRY: {
                    this.setValidLabel(this.ccExpWrapperRef);
                    validExpirationDate();
                    break;
                }
                default: {
                    console.warn('[PaymentsForm] Unknown validation field');
                }
            }
        }
        else {
            switch (fieldName) {
                case EValidationFields.CC_NUMBER: {
                    this.setErrorLabel(this.ccNumberWrapperRef);
                    invalidCCNumber(message);
                    break;
                }
                case EValidationFields.CVV: {
                    this.setErrorLabel(this.cvvWrapperRef);
                    invalidCVVNumber(message);
                    break;
                }
                case EValidationFields.CC_EXPIRY: {
                    this.setErrorLabel(this.ccExpWrapperRef);
                    invalidExpirationDate(message);
                    break;
                }
                default: {
                    console.warn('[PaymentsForm] Unknown validation field');
                }
            }
        }
    };
    // Add a focused class to the collect.js input wrapper when a focus event
    // is received
    PaymentForm.prototype.handleFocusInput = function (event) {
        var frameContainer = event.target.parentElement;
        if (frameContainer) {
            var inputContainer = frameContainer.parentElement;
            if (inputContainer) {
                inputContainer.classList.add(styles.Input___focus);
                this.setState({
                    isFocused: true,
                });
            }
        }
    };
    // Remove classes from the collect.js input wrapper when a blur event is
    // received and the input is empty, otherwise leave the classes as is
    PaymentForm.prototype.handleBlurInput = function (event) {
        var frameContainer = event.target.parentElement;
        if (frameContainer) {
            var inputContainer = frameContainer.parentElement;
            if (inputContainer && event.detail && event.detail.empty) {
                inputContainer.classList.remove(styles.Input___focus);
                inputContainer.classList.remove(styles.Input___valid);
                inputContainer.classList.remove(styles.Input___error);
            }
        }
    };
    // The collect.js inline fields are available
    PaymentForm.prototype.fieldsAvailableCallback = function () {
        var loadedCollectJS = this.props.loadedCollectJS;
        loadedCollectJS();
        // We need to add event listeners to determine when to focus and give
        // the right behavior to the collectjs inputs
        //
        // SEE: https://github.com/microsoft/TypeScript/issues/28357
        var frames = document.querySelectorAll("." + styles.Input + " iframe.CollectJSInlineIframe");
        if (frames) {
            for (var i = 0; i < frames.length; i++) {
                frames[i].addEventListener('focus', this.handleFocusInput);
                frames[i].addEventListener('blur', this.handleBlurInput);
            }
        }
        this.setState({
            isFieldsAvailable: true,
        });
    };
    // Submit a payment method
    // TODO: this is here only for completeness... It isn't actually used here
    // for flexibility reasons
    //
    // TODO: refactor to include this for completeness
    //
    // I'm thinking compound component that allows you to place the submission
    // button and the payment form anywhere you want while still being able to
    // place your own content...
    // function submit(): void {
    //     submitPaymentForm();
    // }
    // Render input field error messages
    PaymentForm.prototype.renderError = function (error) {
        if (error !== '') {
            return React__default.createElement("span", { className: styles.Error }, error);
        }
        return null;
    };
    PaymentForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, error = _a.error, isLoading = _a.isLoading, ccNumber = _a.ccNumber, ccNumberError = _a.ccNumberError, ccNumberLabel = _a.ccNumberLabel, expirationDate = _a.expirationDate, expirationDateLabel = _a.expirationDateLabel, ccExpError = _a.ccExpError, cvvError = _a.cvvError, cvvLabel = _a.cvvLabel, postalCodeInputStyles = _a.postalCodeInputStyles, ccNumberInputStyles = _a.ccNumberInputStyles, ccExpiryInputStyles = _a.ccExpiryInputStyles, cvvInputStyles = _a.cvvInputStyles, postalCode = _a.postalCode, postalCodeError = _a.postalCodeError, postalCodeLabel = _a.postalCodeLabel, variant = _a.variant, isPostalCodeInputVisible = _a.isPostalCodeInputVisible;
        var _b = this.state, isFieldsAvailable = _b.isFieldsAvailable, isPostalCodeDirty = _b.isPostalCodeDirty;
        return (React__default.createElement("div", { className: styles.PaymentForm },
            React__default.createElement("div", { className: !error && (isLoading || !isFieldsAvailable)
                    ? styles.Visible
                    : styles.Hidden }, "Loading..."),
            React__default.createElement("div", { className: !isLoading && isFieldsAvailable
                    ? styles.Visible
                    : styles.Hidden },
                React__default.createElement("form", { className: styles.Form },
                    React__default.createElement("div", { className: styles.Input + " " + (ccNumberInputStyles || '') + " " + (this.hasPreviousInfoIgnoreFocus()
                            ? styles.Input___focus
                            : ''), ref: this.ccNumberWrapperRef },
                        React__default.createElement("label", { htmlFor: "collectjs-ccnumber", onClick: function () {
                                return _this.showInput(_this.ccNumberWrapperRef);
                            } }, ccNumberLabel),
                        React__default.createElement("div", { id: "collectjs-ccnumber-" + this.id }),
                        React__default.createElement("div", { className: styles.Input_prev + " " + (this.hasPreviousInfo()
                                ? styles.Input_prev___visible
                                : '') }, ccNumber),
                        this.renderError(ccNumberError)),
                    React__default.createElement("div", { className: styles.Input + " " + (ccExpiryInputStyles || '') + " " + (this.hasPreviousInfoIgnoreFocus()
                            ? styles.Input___focus
                            : ''), ref: this.ccExpWrapperRef },
                        React__default.createElement("label", { htmlFor: "collectjs-ccexp", onClick: function () {
                                return _this.showInput(_this.ccExpWrapperRef);
                            } }, expirationDateLabel),
                        React__default.createElement("div", { id: "collectjs-ccexp-" + this.id }),
                        React__default.createElement("div", { className: styles.Input_prev + " " + (this.hasPreviousInfo()
                                ? styles.Input_prev___visible
                                : '') }, this.formatExpirationDate(expirationDate)),
                        this.renderError(ccExpError)),
                    React__default.createElement("div", { className: styles.Input + " " + (cvvInputStyles || '') + " " + (this.hasPreviousInfoIgnoreFocus()
                            ? styles.Input___focus
                            : ''), ref: this.cvvWrapperRef },
                        React__default.createElement("label", { htmlFor: "collectjs-cvv", onClick: function () {
                                return _this.showInput(_this.cvvWrapperRef);
                            } }, cvvLabel),
                        React__default.createElement("div", { id: "collectjs-cvv-" + this.id }),
                        React__default.createElement("div", { className: styles.Input_prev + " " + (this.hasPreviousInfo()
                                ? styles.Input_prev___visible
                                : '') }, "***"),
                        this.renderError(cvvError)),
                    isPostalCodeInputVisible && (React__default.createElement("div", { className: "" + (postalCodeInputStyles || '') },
                        React__default.createElement(Input, { variant: variant, value: postalCode, label: postalCodeLabel, clearable: false, onChange: this.handleChangePostalCode, errorMessage: postalCodeError, className: styles.UnsetHeight, isValid: !isPostalCodeDirty ||
                                isValidUSorCanadaPostalCode(postalCode) })))))));
    };
    PaymentForm.defaultProps = __assign({}, defaultProps);
    return PaymentForm;
}(React__default.Component));

export default PaymentForm;
